<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style>

:root {
    --light-gray-font: #909090;
    --light-gray-font2: #939393;
    --dark-gray-font: #696969;
    --dark-gray: #252525;
    --light-brown: #98762d;
    --dark-brown: #7d6125;
    --dark-brown-trans: #7d6125BB;
    --dark-brown-font: #7e6227;
    --light-yellow: #fbf3e4;
    --height-news: 12vh;
    --height-news_m: 10vh;

    --menu-icon-top: 1vh;
    /*--menu-icon-gray: #B0B0B0;*/
    --menu-icon-gray: var(--light-yellow);
    --menu-icon-height: 0.4vh;
    --menu-icon-width: 4vh;
    --menu-icon-width_small: 2.7vh;
    /*--menu-icon-spacing: 0.7rem;*/
    --menu-icon-spacing: 1.5vh;
}

@font-face {
    font-family: 'Hanie'; /* Cursiva */
    src: url('assets/fonts/Hanie.ttf'); /*URL to font*/
}

@font-face {
  font-family: 'NomineeExtraLight'; /*a name to be used later*/
  src: url('assets/fonts/NomineeExtraLight.otf'); /*URL to font*/
}

@font-face {
  font-family: 'NomineeMedium'; /*a name to be used later*/
  src: url('assets/fonts/NomineeMedium.otf'); /*URL to font*/
}

@font-face {
  font-family: 'NomineeMediumExtended'; /*a name to be used later*/
  src: url('assets/fonts/NomineeMediumExtended.otf'); /*URL to font*/
}

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    padding: 0;
    margin: 0;
    /*background-color: yellow;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue